import { combineReducers } from "redux";
import allCasesReducer from "./allCasesReducer";
import myLibraryRedcuer from "./myLibraryReducer";
import newCasesReducer from "./newCasesReducer";

const userCasesReducer = combineReducers({
    myLibrary: myLibraryRedcuer,
    allCases: allCasesReducer,
    newCases: newCasesReducer
});

export default userCasesReducer;
